import { render, staticRenderFns } from "./CategoryManage.vue?vue&type=template&id=38233c03&"
import script from "./CategoryManage.vue?vue&type=script&lang=js&"
export * from "./CategoryManage.vue?vue&type=script&lang=js&"
import style0 from "./CategoryManage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports